var getSmallAddress = rawAddress => {
  const { city, neighborhood, state, street } = rawAddress;

  return [state, city, neighborhood, street]
    .filter(Boolean)
    .slice(-2)
    .join('. ');
};

export { getSmallAddress as default };
//# sourceMappingURL=get-small-address.js.map
